import { DailyEngagement } from '../components/pages/portal/engagement-gauge/models/engagement.model';

export class Project {
    projectId:string;
    organizationId:string;
    organizationname:string;
    orgdesc:string;
    orgemail:string;
    orgwww:string;
    orglogourl:string;
    fullname:string;
    title:string;
    subtitle?:string;
    shortdescription?:string;
    projectdescription?:string;
    projectscope:string;
    projectlocation?:string;
    creator:string;
    created:Date;
    customer:string;
    customername:string;
    start_date:Date;
    end_date:Date;
    templateId:string;
    isactive:boolean;
    canedit:boolean;
    overduedays:number;
    progress:number;
    dealId?:string;
    dealcrmId?:string;
    lastupdated:number;
    workload_fte?: number;  // FTE workload for this project (default: 1.0)
    completed_date?: string;  // ISO date when project was completed
    
    // Customer engagement data (optional - loaded from cached engagement on project metadata)
    engagement?: DailyEngagement[];
}